module.exports = __webpack_public_path__ + "img/salonBanner1.0de28ac5.png";